// extracted by mini-css-extract-plugin
export default {"relations__header":"lsf-relations__header","relations__title":"lsf-relations__title","relations__content":"lsf-relations__content","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630377033
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  